export enum LocalStores {
  checkout = "ga-ref",
}

export default {
  setItem(key: LocalStores, item: any) {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(key, JSON.stringify(item))
    }
  },
  getItem(key: LocalStores) {
    if (typeof window !== "undefined") {
      try {
        return JSON.parse(window.localStorage.getItem(key))
      } catch (error) {
        return window.localStorage.getItem(key)
      }
    }
  },
  clear() {
    if (typeof window !== "undefined") {
      window.localStorage.clear()
    }
  },
  removeItem(key: LocalStores) {
    if (typeof window !== "undefined") {
      window.localStorage.removeItem(key)
    }
  },
}
